import React from 'react';

interface IProps {
  text: string;
}

export const Appeals = ({ text }: IProps) => {
  return <div className={'whitespace-nowrap h-min-content flex items-center p-1'}>{text}</div>;
};
